var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1515 10.084L13.6885 10.5159L12.1707 9.1018L11.6607 9.57748L10.2178 8.23485L9.77742 8.6456L8.7174 7.65689L6.62696 9.6067L6.27014 9.27389L5.0117 10.4477C3.54961 8.61637 3.95517 6.02529 5.91855 4.66156C7.88192 3.29783 10.6599 3.6761 12.122 5.5074C12.1933 5.59506 12.2595 5.68598 12.3221 5.78014L12.5119 6.05776L16 3.97645L15.8085 3.69883C13.2621 -0.0254475 7.95851 -1.11968 3.96561 1.25548C-0.0272846 3.63064 -1.20044 8.57741 1.34603 12.3017C2.923 14.607 5.65224 16.0016 8.58338 16C11.2621 15.9756 13.7825 14.8084 15.4256 12.8342C16.0435 11.9689 15.9669 11.753 15.9669 11.753L14.1515 10.084ZM12.1725 9.57261L13.135 10.4704H12.8165V11.0256L12.1725 10.4249V9.57261ZM4.24236 11.6507L3.24849 11.9965L3.90295 11.3877V10.7756L5.21361 11.9965L4.24236 11.6507ZM7.15784 11.1571H6.2684L6.58867 10.8584L6.2684 9.74633L8.71914 12.0289L7.15784 11.1571ZM11.3422 11.4964L9.85052 11.8666L8.7174 10.8016H10.0507L7.93762 9.91192L9.5581 9.65379L8.07861 9.17323L9.06378 8.92646L8.7174 8.13095L13.2934 12.3942L11.3422 11.4964ZM15.0357 11.6767H14.1515V10.9786H13.6989L14.1515 10.5581L15.7876 12.0809L15.0357 11.6767Z",
    fill: "#243547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredova);
export default __webpack_public_path__ + "static/media/credova.0b73b50bd96772f67d9e6b2c1887e89d.svg";
export { ForwardRef as ReactComponent };